import FileViewer from "react-file-viewer";


const PreviewDocx = ({ data }) => {

  return (
    <FileViewer 
      fileType={data.extension} 
      className="w-100 h-100"
      filePath={data.preview} 
      onContextMenu={(e) => e.preventDefault()}
    />
  )
}

export default PreviewDocx